exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/mike/Documents/github/crypto/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/mike/Documents/github/crypto/node_modules/postcss-loader?{"ident":"postcss"}!/Users/mike/Documents/github/crypto/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/Users/mike/Documents/github/crypto/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles